import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { ConfiguredEmailContextType } from 'wisestep-api';

import SettingsIndex from '../../components/SettingsIndex';
import { useEmailConfigurationContext } from '../../context';
export interface emailCountType {
  gmail: number;
  microsoft: number;
  yahoo: number;
  godaddy: number;
  customMail: number;
}
const WsSmtpSetup = () => {
  const configuredContext = useEmailConfigurationContext();
  const [emailCount, setEmailCount] = useState<emailCountType>({
    gmail: 0,
    microsoft: 0,
    yahoo: 0,
    godaddy: 0,
    customMail: 0,
  });
  useEffect(() => {
    if (configuredContext?.configuredData != null) {
      setEmailCount({
        gmail: configuredContext.configuredData.filter(
          (data: ConfiguredEmailContextType) => data.host === 'smtp.gmail.com'
        ).length,
        microsoft:
          configuredContext.configuredData.filter(
            (data: ConfiguredEmailContextType) => data.host === 'smtp.outlook.com'
          ).length ?? 0,
        yahoo:
          configuredContext.configuredData.filter(
            (data: ConfiguredEmailContextType) => data.host === 'smtp.mail.yahoo.com'
          ).length ?? 0,
        godaddy:
          configuredContext.configuredData.filter(
            (data: ConfiguredEmailContextType) => data.host === 'smtp.mail.yahoo.com'
          ).length ?? 0,
        customMail:
          configuredContext.configuredData.filter((data: ConfiguredEmailContextType) => {
            if (
              !(data.host === 'smtp.gmail.com') &&
              !(data.host === 'smtp.microsoft.com') &&
              !(data.host === 'smtp.mail.yahoo.com') &&
              !(data.host === 'smtpout.secureserver.net')
            )
              return data;
          }).length ?? 0,
      });
    }
  }, [configuredContext]);
  return (
    <Box>
      <SettingsIndex
        options={[
          {
            label: 'Send Email Settings',
            url: '/email-settings/',

            subOptions: [
              { label: 'Gmail', url: '/email-settings/', count: emailCount.gmail },
              {
                label: 'Microsoft',
                url: '/email-settings/microsoft/',
                count: emailCount.microsoft,
              },
              { label: 'Yahoo', url: '/email-settings/yahoo/', count: emailCount.yahoo },
              { label: 'GoDaddy', url: '/email-settings/godaddy/', count: emailCount.godaddy },
              {
                label: 'Custom Mail ',
                url: '/email-settings/custom-mail/',
                count: emailCount.customMail,
              },
            ],
          },
          {
            label: 'Email Inbox',
            url: '/email-settings/configure-email-inbox/',
          },
          { label: 'Notification Preferences', url: '/email-settings/preferences/' },
          { label: 'Signature', url: '/email-settings/signature/' },
        ]}
      />
    </Box>
  );
};
export default WsSmtpSetup;
